<template>
  <div class="p-right-25-important" ref="call_logs_section">
    <!-- Display call logs grouped by date -->
    <div v-if="Object.keys(callLogs).length > 0">
      <div v-for="(group, date) in callLogs" :key="date">
        <div class="row mobile-p-bottom-0">
          <div class="col-md-offset-3 col-md-6 created-date">
            {{ date }}
          </div>
        </div>
        <div></div>
        <call-log-row
          v-for="(log, index) in group"
          :log="log"
          :key="log.call_log_id"
        ></call-log-row>
      </div>
      <!-- Display "Load More" button if there are more logs to load -->
      <div v-if="hasMoreLogs && !isLoading" class="row load-more-button">
        <button class="btn btn-default" @click="loadMoreLogs">Load More</button>
      </div>
      <!-- Display a message when there are no more logs to load -->
      <div v-else class="no-more-logs">No more call logs to load.</div>
      <div v-if="isLoading" class="row">
        <div class="col-md-6 col-md-offset-5">
          <img src="/pic/loading-4.gif" />
        </div>
      </div>
    </div>
    <div v-else class="inquiry-no-result">
      <br />
      <h3 class="font-bold"><span class="fa fa-ban"></span> No Calls Logged
      </h3>
      <p class="font-14 w-80">
         No phone calls have been logged for this customer yet.
        This tab will display the history of all calls made or received through the system.
        If you have call recording enabled in your integrated VOIP system,
        you can also listen to the recordings here.
      </p>
    </div>
  </div>
</template>

<script>
import { getAllCallLogs } from "@/modules/Booking/api/BookingViewTabs";
import CallLogRow from "./CallLogRow.vue";

export default {
  name: "CallLogTab",
  components: { CallLogRow },
  props: {
    value: {
      type: Object,
    },
    itemType: {
      type: String,
      required: true,
    },
    itemId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      callLogs: {},
      currentPage: 1,
      perPage: 10,
      hasMoreLogs: false,
      isLoading: false,
    };
  },
  methods: {
    loadCallLogs() {
      const params = {
        item_id: this.itemId,
        item_type: this.itemType,
        page_number: this.currentPage,
      };

      getAllCallLogs(params)
        .then((response) => {
          const newLogs = response.data.msg;
          if (newLogs.length > 0) {
            this.groupCallLogs(newLogs);
            this.currentPage += 1;
            if (newLogs.length < this.perPage) this.hasMoreLogs = false;
            else this.hasMoreLogs = true;
          } else {
            this.hasMoreLogs = false;
          }
          this.isLoading = false;
          $(this.$refs.call_logs_section).LoadingOverlay("hide");
        })
        .catch((error) => {
          console.error("Error loading call logs: ", error);
        });
    },
    loadMoreLogs() {
      this.isLoading = true;
      // Load more logs when the "Load More" button is clicked
      this.loadCallLogs();
    },
    groupCallLogs(logs) {
      let vm = this;
      // Group call logs by date
      logs.forEach((log) => {
        const dateKey = log.date_formated;
        if (!vm.callLogs[dateKey]) {
          // Use Vue.set to add new properties and ensure reactivity
          this.$set(this.callLogs, dateKey, []);
        }
        vm.callLogs[dateKey].push(log);
      });
      vm.$emit("input", this.callLogs);
    },
  },
  mounted() {
    $(this.$refs.call_logs_section).LoadingOverlay("show");
    this.loadCallLogs(); // Load initial data when component is mounted
  },
};
</script>

<style scoped>
.created-date {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  color: rgb(98, 112, 124);
}
.load-more-button {
  text-align: center;
}
.no-more-logs {
  text-align: center;
}
.p-right-25-important {
  padding-right: 25px !important;
}
@media (max-width: 991px) {
  .mobile-p-bottom-0 {
    padding-bottom: 0px;
  }
}
.font-14{
  font-size:14px
}
.w-80{
  width:80%;
  margin: auto;
}
</style>
